import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import TabbedPane from '../../components/plain/TabbedPane';
import Label from '../../components/plain/Label';
import LabelField from '../../components/plain/LabelField';
import FieldString from '../../components/plain/FieldString';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldDate from '../../components/plain/FieldDate';
import FieldList_Enum from '../../components/plain/FieldList_Enum';

import TabAANames from './components/TabAANames';
import TabAAImages from './components/TabAAImages';
import TabAACommunications from './components/TabAACommunications';
import TabAAEducation from './components/TabAAEducation';
import TabAAPublications from './components/TabAAPublications';
import TabAAHonors from './components/TabAAHonors';
import TabAABiography from './components/TabAABiography';
import TabAAAbout from './components/TabAAAbout';
import TabAAEvents from './components/TabAAEvents';
import TabAASources from './components/TabAASources';
import FieldGlobalId from './components/FieldGlobalId';

import {getLanguage, hasAccess} from '../../util/localStorage';
import { CLASS_AUTHORITY_AUTHOR } from '../../util/consts/classes';
import {FORM_AUTHORITY_AUTHOR_PLAIN} from '../../util/consts/forms';
import { 
	ENUMERATION_LANGUAGE,
} from '../../util/consts/common';

class AuthorityAuthorPlainPage extends PlainPage {

	enumLanguage = null;

	constructor(props) {
		super(props);
		this.formPath = FORM_AUTHORITY_AUTHOR_PLAIN;
		this.formTitle = 'Автор';
		this.buildInstanceCard = this.buildAuthorCard;
	}
	async completeInit() {
		this.enumLanguage = this.realm.getEnumeration( ENUMERATION_LANGUAGE );
		
		return true;
	}
	componentDidMount = async () => {
		this.init( CLASS_AUTHORITY_AUTHOR );
		document.title = 'BOM. ' + this.formTitle;
	}

	buildAuthorCard = (authorInstance) => {
		let card = '';
		let currentLanguage = getLanguage();
		let name = null;
		for(let n of authorInstance.rootField.value.name.value) {
			if( n.value.language.value == currentLanguage && n.value.shortName.value ) {
				name = n;
				break;
			}
		}
		if( name == null && authorInstance.rootField.value.name.value.length > 0)
			name = authorInstance.rootField.value.name.value[0];
		if( name != null  && name.value.shortName.value ) {
			card += name.value.shortName.value;
		} 
		return card;
	}

	createTab = (tabId) => {
		let readOnly = this.instanceReadOnly;
		if( tabId == 'names' )
			return <TabAANames plain={this} instance={this.state.instance} readOnly={readOnly} />;
		if( tabId == 'images' )
			return <TabAAImages plain={this} instance={this.state.instance} readOnly={readOnly} />;
		if( tabId == 'communications' )
			return <TabAACommunications plain={this} instance={this.state.instance} readOnly={readOnly} />;
		if( tabId == 'education' )
			return <TabAAEducation plain={this} instance={this.state.instance} readOnly={readOnly} />;
		if( tabId == 'publications' )
			return <TabAAPublications plain={this} instance={this.state.instance} readOnly={readOnly} />;
		if( tabId == 'honors' )
			return <TabAAHonors plain={this} instance={this.state.instance} readOnly={readOnly} />;
		if( tabId == 'biography' )
			return <TabAABiography plain={this} instance={this.state.instance} readOnly={readOnly} />;
		if( tabId == 'about' )
			return <TabAAAbout plain={this} instance={this.state.instance} readOnly={readOnly} />;
		if( tabId == 'events' )
			return <TabAAEvents plain={this} instance={this.state.instance} readOnly={readOnly} />;
		if( tabId == 'sources' )
			return <TabAASources plain={this} instance={this.state.instance} readOnly={readOnly} />;
			
		return null;
	}

	renderBody() {
		let tabPart1 = [
			{ tabId: 'names', tabTitle: 'Імена', },
			{ tabId: 'images', tabTitle: 'Зображення', },
		]
		if( hasAccess( 'communication_info_acc' ) ) 
			tabPart1.push( { tabId: 'communications', tabTitle: 'Комунікації', }, );
		let tabPart2 = [
			{ tabId: 'education', tabTitle: 'Освіта', },
			{ tabId: 'publications', tabTitle: 'Публікації', },
			{ tabId: 'honors', tabTitle: 'Премії', },
			{ tabId: 'biography', tabTitle: 'Біографія', },
			{ tabId: 'about', tabTitle: 'Про нього', },
			{ tabId: 'events', tabTitle: 'Події', },
			{ tabId: 'sources', tabTitle: 'Джерела', },
		]
		let tabs = [
			{
				rowId: 'first',
				tabs: tabPart1.concat(tabPart2)
			},
		];
		let instance = this.state.instance;
		let readOnly = this.instanceReadOnly;
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
						<FieldGlobalId instance={instance} plain={this}
							readOnly={readOnly}
							styles={{ input: {minWidth: '250px', flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldEnum instance={instance} path={'/subjectType'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1', marginRight: '20px'}}} 
						/>
						<Label title={'Дати життя'} tooltip={'Дати життя автора'} styles={{divMain: {marginRight: '10px'}}} />
						<FieldDate instance={instance} path={'/startDate'} plain={this} 
							readOnly={readOnly}
							ignoreTitle={true} styles={{ input: {flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldDate instance={instance} path={'/stopDate'} plain={this} 
							readOnly={readOnly}
							ignoreTitle={true} styles={{ input: {flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldString instance={instance} path={'/dates'} plain={this} 
							readOnly={readOnly}
							ignoreTitle={true} styles={{ input: {flexGrow: '1', width: '100px', marginRight: '20px'} }}
						/>
					</div>
					<FieldList_Enum
						instance={instance} path={'language'} plain={this}
						labelEmptyToHeader={true}
						readOnly={readOnly}
						styles={{divMain: {flexGrow: '1'}}}
					/>
					<TabbedPane tabs={tabs} createTab={this.createTab} 
						styles={{ divMain: {border: '1px solid gray', marginTop: '10px'} }} 
					/>
					<div style={{marginTop: '15px'}}>
						<LabelField instance={instance} path={'comment'} />
						<FieldString  instance={instance} path={'comment'} plain={this}
							multiline={true} rows={2} cols={60}
							readOnly={readOnly}
							styleInput={{width: '98%'}} ignoreTitle={true}
						 />
					</div>
				</div>
			</div>
		)
	}
}


export default AuthorityAuthorPlainPage;
